import React from 'react';
import { Box, Typography } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { TaskChip } from '../TaskChip';
import { TaskEditForm } from '../TaskEditForm';
import { TaskListProps } from '../types';
import { getTaskListStyles, getDraggableItemStyles } from './TaskList.styles';
import { useSortedTasks, useTaskToggle, useDragEnd, useSaveEdit } from './TaskList.hooks';

export const TaskList: React.FC<TaskListProps> = ({
     tasks,
     selectedTasks,
     selectedMilestone,
     editingTaskId,
     onTasksChange,
     onDeleteTask,
     onRenameTask,
     onReorderTasks,
     onStartEdit,
     onCancelEdit,
     allTaskNames,
     currentMilestones,
}) => {
     // Use custom hooks
     const sortedTasks = useSortedTasks(tasks);
     const handleTaskToggle = useTaskToggle(selectedTasks, onTasksChange);
     const handleDragEnd = useDragEnd(selectedMilestone, onReorderTasks, sortedTasks);
     const handleSaveEdit = useSaveEdit(onRenameTask);

     if (sortedTasks.length === 0) {
          return (
               <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic', mt: 1 }}>
                    No tasks available for this milestone
               </Typography>
          );
     }

     // return (
     //      <DragDropContext onDragEnd={handleDragEnd}>
     //           <Droppable droppableId="tasks" direction="horizontal">
     //                {(provided, snapshot) => (
     //                     <Box
     //                          ref={provided.innerRef}
     //                          {...provided.droppableProps}
     //                          sx={getTaskListStyles(snapshot.isDraggingOver)}
     //                     >
     //                          {sortedTasks.map((task, index) => (
     //                               <Draggable key={`${task.id}-${task.taskOrder}-${index}`} draggableId={task.id} index={index}>
     //                                    {(provided, snapshot) => (
     //                                         <Box
     //                                              ref={provided.innerRef}
     //                                              {...provided.draggableProps}
     //                                              {...provided.dragHandleProps}
     //                                              sx={getDraggableItemStyles(snapshot.isDragging)}
     //                                         >
     //                                              {editingTaskId === task.id ? (
     //                                                   <TaskEditForm
     //                                                        taskId={task.id}
     //                                                        taskName={task.taskName}
     //                                                        onSave={handleSaveEdit}
     //                                                        onCancel={onCancelEdit}
     //                                                   />
     //                                              ) : (
     //                                                   <TaskChip
     //                                                        task={task}
     //                                                        isSelected={selectedTasks.includes(task.taskName)}
     //                                                        isDragging={snapshot.isDragging}
     //                                                        onToggle={handleTaskToggle}
     //                                                        onEdit={onStartEdit}
     //                                                        onDelete={onDeleteTask}
     //                                                        selectedMilestone={selectedMilestone}
     //                                                   />
     //                                              )}
     //                                         </Box>
     //                                    )}
     //                               </Draggable>
     //                          ))}
     //                          {provided.placeholder}
     //                     </Box>
     //                )}
     //           </Droppable>
     //      </DragDropContext>
     // );
     return (
          <Box sx={getTaskListStyles(false)}>
               {sortedTasks.map((task, index) => (
                    <Box key={`${task.id}-${task.taskOrder}-${index}`}>
                         {editingTaskId === task.id ? (
                              <TaskEditForm
                                   taskId={task.id}
                                   taskName={task.taskName}
                                   onSave={handleSaveEdit}
                                   onCancel={onCancelEdit}
                                   existingTaskNames={allTaskNames || tasks.map((t) => t.taskName)}
                                   currentMilestones={currentMilestones}
                                   milestoneName={selectedMilestone}
                              />
                         ) : (
                              <TaskChip
                                   task={task}
                                   isSelected={selectedTasks.includes(task.taskName)}
                                   isDragging={false}
                                   onToggle={handleTaskToggle}
                                   onEdit={onStartEdit}
                                   onDelete={onDeleteTask}
                                   selectedMilestone={selectedMilestone}
                                   numberOfTasks={tasks.length}
                              />
                         )}
                    </Box>
               ))}
          </Box>
     );
}; 